const fr = {
	appName: 'resolvo.me',
	welcomeMessage: 'Gérez et suivez vos résolutions du Nouvel An',
	signInToYourAccount: 'Connectez-vous à votre compte',
	createYourAccount: 'Créez votre compte',
	firstName: 'Prénom',
	lastName: 'Nom',
	emailAddress: 'Adresse e-mail',
	password: 'Mot de passe',
	confirmPassword: 'Confirmer le mot de passe',
	signUp: "S'inscrire",
	signIn: 'Se connecter',
	processing: 'Traitement...',
	dontHaveAccountSignUp: "Vous n'avez pas de compte ? Inscrivez-vous",
	alreadyHaveAccountSignIn: 'Vous avez déjà un compte ? Connectez-vous',
	resetPassword: 'Réinitialiser le mot de passe',
	sendResetEmail: 'Envoyer l e-mail de réinitialisation',
	sending: 'Envoi...',
	rememberMe: 'Se souvenir de moi',
	forgotPassword: 'Mot de passe oublié ?',
	adminDashboard: "Tableau d'administration",
	myDashboard: 'Mon tableau de bord',
	myProfile: 'Mon profil',
	settings: 'Paramètres',
	signOut: 'Se déconnecter',
	addResolution: 'Ajouter une résolution',
	cancel: 'Annuler',
	makePrivate: 'Rendre cette résolution privée (chiffrée)',
	encryptionKey: 'Clé de chiffrement',
	enterEncryptionKey: 'Entrez une clé sécurisée pour chiffrer votre résolution',
	rememberEncryptionKey: 'Souvenez-vous de cette clé ! - vous en aurez besoin pour voir votre résolution privée',
	type: 'Type',
	year: 'Année',
	resolutionText: 'Texte de la résolution',
	exampleCount: 'ex. Lire 20 livres cette année',
	exampleBinary: 'ex. Acheter une nouvelle voiture',
	exampleMetric: "ex. Perdre 10 kg d'ici la fin de l'année",
	startValue: 'Valeur de départ',
	targetValue: 'Valeur cible',
	unit: 'Unité',
	unitExample: 'ex. kg, km, heures, USD',
	exampleStreak: "ex. Boire 2 L d'eau chaque jour (enregistrer quotidiennement)",
	currentStreak: 'Série actuelle',
	longestStreak: 'Plus longue série',
	never: 'Jamais',
	measurements: 'Mesures',
	lastLogDate: 'Dernière date d enregistrement',
	daysInARow: 'jours de suite',
	dailyInARow: 'jours de suite',
	weeklyInARow: 'semaines de suite',
	monthlyInARow: 'mois de suite',
	period: 'Période',
	daily: 'Quotidien',
	weekly: 'Hebdomadaire',
	monthly: 'Mensuel',
	value: 'Valeur',
	note: 'Note',
	add: 'Ajouter',
	loading: 'Chargement...',
	resolutions: 'Résolutions',
	claimAccount: 'Vous devez réclamer votre compte pour ajouter des résolutions',
	timeUntilNewYear: 'Temps avant le Nouvel An',
	contactAdmin: "Contactez l'administrateur pour vos résolutions...",
	verifyingLink: 'Vérification de votre lien...',
	invalidLink: 'Lien invalide',
	goToLogin: 'Aller à la connexion',
	completeAccountClaim: 'Terminer la réclamation du compte',
	emailVerifiedCreatePassword: 'E-mail vérifié ! Créez un mot de passe pour sécuriser votre compte.',
	accountLabel: 'Compte',
	createPasswordLabel: 'Créer un mot de passe',
	confirmPasswordLabel: 'Confirmer le mot de passe',
	enterYourPassword: 'Entrez votre mot de passe',
	confirmYourPassword: 'Confirmez votre mot de passe',
	creatingAccount: 'Création du compte...',
	completeClaim: 'Terminer la réclamation',
	backToLogin: 'Retour à la connexion',
	passwordMismatch: 'Les mots de passe ne correspondent pas',
	passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
	invalidOrExpiredLink: 'Lien de vérification invalide ou expiré',
	linkNotFound: 'Lien de vérification introuvable ou expiré',
	linkExpiredRequestNew: 'Le lien de vérification a expiré. Veuillez en demander un nouveau.',
	accountAlreadyClaimed: 'Ce compte a déjà été réclamé',
	failedToCreateAccount: 'Échec de la création du compte. Veuillez réessayer.',
	claimErrorGeneric: 'Une erreur est survenue lors de la réclamation',
	resolution: 'résolution',
	total: 'total',
	overallProgress: 'Progrès global',
	progress: 'Progrès',
	completed: 'Terminé',
	complete: 'Compléter',
	'waiting-completion': 'En attente de finalisation',
	ahead: 'En avance',
	behind: 'En retard',
	'on-track': 'Sur la bonne voie',
	failed: 'Échoué',
	private: 'Privé',
	decrypt: 'Déchiffrer',
	delete: 'Supprimer',
	backToPlrofile: '← Retour au profil',
	customizeProfile: 'Personnalisez votre profil et vos préférences',
	displayNameHeading: 'Nom affiché',
	displayNameHelp: 'Comment votre nom apparaît sur votre profil',
	enterDisplayName: 'Entrez votre nom affiché',
	currentlyShowing: 'Actuellement affiché',
	emailPreferences: 'Préférences e-mail',
	requiredForReceiving: 'Requis pour recevoir les notifications par e-mail',
	weeklyStatusEmail: 'E-mail d état hebdomadaire',
	emailRequired: '(Adresse e-mail requise)',
	timerStyle: 'Style du minuteur',
	chooseTimer: 'Choisissez comment vous voulez que votre compte à rebours apparaisse',
	selected: 'Sélectionné',
	preview: 'Aperçu :',
	saving: 'Enregistrement...',
	saveSettings: 'Enregistrer les paramètres',
	count: 'Compter',
	binary: 'Oui/Non',
	metric: 'Changement métrique',
	streak: 'Série',
	yes: 'Oui',
	no: 'Non',
	'timer.months': 'Mois',
	'timer.days': 'Jours',
	'timer.hours': 'Heures',
	'timer.minutes': 'Minutes',
	'timer.seconds': 'Secondes',
	'timer.monthsShort': 'MO',
	'timer.daysShort': 'J',
	'timer.hoursShort': 'HRS',
	'timer.minutesShort': 'MIN',
	'timer.secondsShort': 'SEC',
	'timer.monthsShortLower': 'mo',
	'timer.daysShortLower': 'j',
	'timer.hoursShortLower': 'h',
	'timer.minutesShortLower': 'm',
	'timer.secondsShortLower': 's',
	'timer.yearEnded': '🎉 L année est terminée !',
	'timer.option.basic.name': 'Minimaliste sur une ligne',
	'timer.option.basic.desc': 'Format propre et simple sur une seule ligne',
	'timer.option.card.name': 'Cartes colorées',
	'timer.option.card.desc': 'Cartes colorées pour chaque unité de temps',
	'timer.option.clock.name': 'Style horloge numérique',
	'timer.option.clock.desc': "Style d'horloge numérique audacieux",
	'timer.option.circular.name': 'Style anneau de progression',
	'timer.option.circular.desc': 'Indicateurs de progression circulaires modernes',
	'timer.option.flip.name': 'Animation FlipCard',
	'timer.option.flip.desc': 'Cartes animées (bureau uniquement)',
	'timer.option.icon.name': 'Texte avec icônes',
	'timer.option.icon.desc': 'Émojis avec texte abrégé',
	resolutionUpdatedSuccessfully: 'Résolution mise à jour avec succès !',
	errorUpdatingResolution: 'Erreur lors de la mise à jour de la résolution',
	failedToUpdateResolution: 'Échec de la mise à jour de la résolution',
	settingsUpdatedSuccessfully: 'Paramètres mis à jour avec succès !',
	errorDeletingResolution: 'Erreur lors de la suppression de la résolution',
	failedToDeleteResolution: 'Échec de la suppression de la résolution',
	failedToUpdateSettings: 'Échec de la mise à jour des paramètres',
	settingsSavedSuccessfully: 'Paramètres enregistrés avec succès !',
	failedToSaveSettings: 'Échec de l enregistrement des paramètres',
	errorSavingSettings: 'Erreur lors de l enregistrement des paramètres',
	resolutionDeletedSuccessfully: 'Résolution supprimée avec succès !',
	// Landing page translations
	landingHeroTitle: 'Transformez vos objectifs en élan',
	landingHeroSubtitle:
		'resolvo.me vous aide à définir des résolutions significatives, à suivre les progrès avec intention et à transformer vos rêves en habitudes durables.',
	landingGetStarted: 'Commencez votre parcours',
	landingLearnMore: 'Voir comment cela fonctionne',
	landingAndroidComingSoon: '📱 Application Android bientôt disponible',
	landingAimTitle: 'Pourquoi resolvo.me ?',
	landingAimDesc:
		'Nous croyons au pouvoir des objectifs clairs et du suivi cohérent. resolvo.me est conçu pour les personnes qui veulent réussir — pas par la perfection, mais par le progrès.',
	// Core Missions
	landingMission1Title: 'Brisez la chute de février',
	landingMission1Desc:
		'La plupart des résolutions du Nouvel An échouent en février — pas parce que les objectifs sont mauvais, mais parce que nous arrêtons de suivre.',
	landingMission2Title: 'Transformez l intention en action',
	landingMission2Desc:
		'Le vrai changement ne vient pas que des promesses. Il vient des choix quotidiens, de la réflexion hebdomadaire et de voir vos progrès se cumuler.',
	landingMission3Title: 'Simplifiez le processus',
	landingMission3Desc:
		'Fixez vos objectifs, enregistrez vos progrès, obtenez des retours hebdomadaires et voyez ce qui fonctionne réellement.',
	landingMission4Title: 'Construisez une capacité durable',
	landingMission4Desc: 'Le changement durable ne concerne pas la perfection — il concerne la cohérence.',
	landingFeature1Title: 'Plusieurs types de résolutions',
	landingFeature1Desc: 'Choisissez la méthode de suivi qui correspond à votre objectif',
	landingFeature2Title: 'Suivre & Visualiser',
	landingFeature2Desc: 'Voyez vos progrès à travers des graphiques, des séries et des insights significatifs',
	landingFeature3Title: 'Mises à jour hebdomadaires',
	landingFeature3Desc: 'Restez responsable avec des résumés par e-mail chaque semaine',
	landingFeature4Title: 'Sûr & Privé',
	landingFeature4Desc: 'Vos données sont chiffrées. Vous possédez vos objectifs.',
	landingResolutionTypesTitle: 'Types de résolutions',
	landingResolutionTypesSubtitle: 'Choisissez le format qui convient le mieux à votre objectif',
	landingBinaryType: 'Binaire (Oui/Non)',
	landingBinaryDesc: 'Contrôles quotidiens simples pour les habitudes et routines',
	landingBinaryExample1: 'Acheter une nouvelle voiture',
	landingBinaryExample2: 'Trouver un nouvel emploi',
	landingCountType: 'Compter',
	landingCountDesc: 'Suivez combien de fois vous faites quelque chose',
	landingCountExample1: 'Lire 20 livres cette année',
	landingCountExample2: 'Écrire 50 articles de blog cette année',
	landingMetricType: 'Métrique',
	landingMetricDesc: 'Suivez une progression numérique avec une valeur de départ et une valeur cible',
	landingMetricExample1: "Perdre 10 kg d'ici la fin de l'année",
	landingMetricExample2: 'Économiser 5 000 $ cette année',
	landingStreakType: 'Série',
	landingStreakDesc: 'Construisez des jours consécutifs de réussite pour amplifier la motivation',
	landingStreakExample1: "Boire 2L d'eau chaque jour",
	landingStreakExample2: 'Écrire 500 mots par jour pour votre roman',
	landingQuote1: 'Le succès est le produit des habitudes quotidiennes — pas des transformations uniques.',
	landingQuote1Author: 'James Clear',
	landingQuote2: "Le secret d'avancer est de commencer.",
	landingQuote2Author: 'Mark Twain',
	landingFeaturesTitle: 'Fonctionnalités conçues pour le succès',
	landingFeatureLogging: 'Enregistrement en une touche',
	landingFeatureLoggingDesc: "Enregistrez vos progrès en quelques secondes, n'importe où",
	landingFeatureHistory: 'Historique des progrès',
	landingFeatureHistoryDesc: "Consultez toutes vos entrées et voyez jusqu'où vous êtes allé",
	landingFeatureReminders: 'Rappels intelligents',
	landingFeatureRemindersDesc: 'Rappels optionnels pour vous maintenir sur la bonne voie',
	landingFeatureExport: 'Exporter vos données',
	landingFeatureExportDesc: 'Téléchargez vos données à tout moment — elles vous appartiennent',
	landingCtaTitle: 'Prêt à faire de cette année la meilleure ?',
	landingCtaDesc: 'Rejoignez des milliers de personnes qui travaillent déjà vers leurs objectifs.',
	landingCtaButton: 'Créez votre première résolution',
	landingFooterAbout: 'resolvo.me : Simple. Privé. Conçu pour ceux qui veulent vraiment changer.',
	landingFooterContact: 'Des questions ? Contactez-nous ou visitez l application',
};

export default fr;
